module.exports = __webpack_public_path__ + "static/2.3-434ada5b90f90d216b45271f1535bbb9.jpg";